import style from './index.scss';
import { searchFlex } from 'js/utils/search.util';
export const highlightStart = `<span class="${style.searchQuery}">`;
export const highlightEnd = '</span>';

export const highlightMatches = ({ value, matchesStart, matchesEnd }) => {
    if (matchesStart.length === 0) {
        return value;
    }

    return value.replace(/(?=.)/g, (char, index) => {
        if (matchesStart.includes(index)) {
            return highlightStart;
        }

        if (matchesEnd.includes(index)) {
            return highlightEnd;
        }

        return '';
    });
};

export const setSearchGamesFn = ({ games, setSearchGames }) => {
    const searchSource = games?.map(game => ({
        id: game.code,
        value: game.name,
        source: game
    }));
    setSearchGames(() => searchFlex(searchSource));
};
